import { mailDeeplinkModuleName } from './strings.locstring.json';
import loc from 'owa-localize';
// Order is important, do not mess with it :)
import * as React from 'react';
import { bootstrap } from 'owa-bootstrap';
import initializeMailModuleState from 'owa-mail-bootstrap/lib/actions/initializeMailModuleState';
import DeepLinkModule from './components/DeepLinkModule';
import { mailRouterOptions, initializeDeepLinkMailRoutes } from './routing/deepLinkMailRoutes';
import { OwaWorkload } from 'owa-workloads';
import { controlIconRegistration } from 'owa-control-icons';
import { mailIconsRegistration } from 'owa-mail-icons';
import { addinIconsRegistration } from 'owa-addins-icons';
import { surfaceActionIconsRegistration } from 'owa-surface-action-icons';
import { getMailAnalyticOptions } from 'owa-mail-shared-analytics';
import 'owa-attachment-preview-initialization/lib/utils/initializeAttachmentPreviewInSxS';
import { PreBootOptions } from 'owa-config';
import {
    lazySetupMailDeeplinkCommonPostRender,
    lazySetupMailModuleCommonPostRender,
} from 'owa-mail-post-boot/lib/deeplinkIndex';
import initializeMailDeeplinkModuleState from './utils/initializeMailDeeplinkModuleState';
import isPopoutLeanBootstrapEnabled from './utils/isPopoutLeanBootstrapEnabled';

export default function bootstrapDeepLink(bootstrapConfig: PreBootOptions): Promise<void> {
    const subRoute = getSubRoute();
    const isLeanBootstrapEnabled = isPopoutLeanBootstrapEnabled();
    let postLazyAction;

    // saveAndEdit is a deeplink that saves an attachment to OneDrive then opens it in that tab.
    // Since we do not need any mail UI, or to make any other service calls we skip
    // initializing everything except the notification channel, which is initialized elsewhere.
    if (subRoute !== 'saveAndEdit') {
        postLazyAction = isLeanBootstrapEnabled
            ? lazySetupMailDeeplinkCommonPostRender
            : lazySetupMailModuleCommonPostRender;
    }
    return bootstrap({
        initializeState: isLeanBootstrapEnabled
            ? initializeMailDeeplinkModuleState
            : initializeMailModuleState,
        renderMainComponent: () => <DeepLinkModule subRoute={subRoute} />,
        initialConfig: bootstrapConfig,
        registerRoutes: initializeDeepLinkMailRoutes,
        routerOptions: mailRouterOptions,
        getModuleName: () => loc(mailDeeplinkModuleName),
        workload: OwaWorkload.Mail,
        analyticsOptions: getMailAnalyticOptions(),
        iconFonts: [
            controlIconRegistration,
            mailIconsRegistration,
            addinIconsRegistration,
            surfaceActionIconsRegistration,
        ],
        postLazyAction,
    });
}

function getSubRoute() {
    const subRouteRegex = /\/(opx)*deeplink\/([a-z]*)\//i;
    const result: RegExpMatchArray = window.location.pathname.match(subRouteRegex);
    return !!result ? result[2] : '';
}
